var map = {
	"./cinema-11.png": 1190,
	"./cinema-12.png": 1191,
	"./cinema-13.png": 1192,
	"./cinema-14.png": 1193,
	"./cinema-15.png": 1194,
	"./cinema-16.png": 1195,
	"./cinema-17.png": 1196,
	"./cinema-18.png": 1197
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1189;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-img/png-img ^\.\/cinema\-1.*\.png$
// module id = 1189
// module chunks = 173